module.exports = __webpack_public_path__ + "img/logo.96e79d11.svg";